import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { map, Observable, of, tap } from "rxjs";
import { Country } from "@modules/country/models/country.model";
import { ExtraJobService } from "@modules/extra-job/services/extra-job.service";
import { appRoutes } from "@config/app-routes.config";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { ExtraJob } from "@modules/extra-job/models/extra-job.model";
import { OrderService } from "@modules/order/services/order.service";
import {CommonModule} from "@angular/common";
import {CheckoutPageComponent} from "@shared/component/payments/pages/checkout-page/checkout-page.component";
import {buildExtraJobsTabQueryParams} from "@modules/job/pages/job-detail/job-detail.component";

@UntilDestroy()
@Component({
  standalone: true,
  imports: [
    CommonModule,
    CheckoutPageComponent,
  ],
  selector: 'app-extra-job-checkout',
  templateUrl: './extra-job-checkout.component.html',
  styleUrls: ['./extra-job-checkout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ExtraJobCheckoutComponent implements OnInit {
  @Input() extraJob?: ExtraJob;
  @Input() shouldRedirect = true;
  redirectUrl: any[];
  redirectQueryParams?: Record<string, string>;

  get extraJob$ (): Observable<ExtraJob> {
    return this.extraJob ? of(this.extraJob) : this.extraJobService.activeEntity$;
  }

  get country$ (): Observable<Country> {
    return this.extraJob$.pipe(map(extraJob => extraJob.job.supportedCountry.country))
  }

  constructor (
    private readonly extraJobService: ExtraJobService,
    private readonly orderService: OrderService,
  ) {
  }

  ngOnInit (): void {
    this.extraJob$.pipe(
      untilDestroyed(this),
      tap(extraJob => {
        if (extraJob) {
          this.orderService.dispatchAddOrUpdateThenSelectEntityAction(extraJob.order)

          this.orderService.setReturnUrl([window.location.origin, 'job', extraJob.jobId].join('/'))

          this.redirectUrl = appRoutes.jobDetail(extraJob.jobId)
          this.redirectQueryParams = buildExtraJobsTabQueryParams(extraJob.id)

        }
      })
    ).subscribe()
  }
}
